/**
 * Created by olga on 26.10.2022
 */

const MergeBonusHintContent = function (options) {
    this.unit = options.unit;
    this.amount = options.amount;

    this.doNotBlock = {
        x: this.unit.dragX + 1, // with offset for mergecounthint
        y: this.unit.dragY - 1
    };
};

MergeBonusHintContent.prototype.hasSameContent = function (options) {
    return Unit.Equals(this.unit, options.unit);
};

MergeBonusHintContent.isApplicable = function (options) {
    let amount = options.amount;
    const unit = options.unit;
    if (!amount || !unit || options.wrongMerged || !unit.findComponent(MergeComponent)) {
        return false;
    }
    const level = cleverapps.gameLevel.getLevel();
    const unitsCount = Families[unit.code].units.length;
    const isTutorialActive = cleverapps.tutorial.isActive() || (Map2dLocation.currentLocation.tutorial && Map2dLocation.currentLocation.tutorial.isActive());

    if (level < 4 && !cleverapps.gameLevel.withOwnLevel() || isTutorialActive || (unit.findComponent(HeroItem) && unit.stage === unitsCount - 2) || unit.isMagicCrystal()) {
        return false;
    }
    if (!unit.getMergeUnit()) {
        return false;
    }
    const totalAmount = Map2d.currentMap.listAvailableUnits(unit).length;
    const mergeBonus = unit.findComponent(MergeComponent).mergeBonus(amount);

    amount = mergeBonus.next;

    if (totalAmount < amount) {
        return false;
    }
    return true;
};

MergeBonusHintContent.prototype.getMessages = function () {
    const unit = this.unit;
    const mergeComponent = unit.findComponent(MergeComponent);
    let amount = this.amount;

    const mergeBonus = mergeComponent.mergeBonus(amount);
    const nextUnit = unit.getMergeUnit();
    amount = mergeBonus.next;

    let text1, text2;

    if (amount <= 17) {
        const nextBonus = mergeComponent.mergeBonus(amount);
        text1 = `${Messages.get("CenterHint.merge.begins")} x${amount}`;
        text2 = `${Messages.get("CenterHint.merge.ends")} x${nextBonus.bonus}`;
    } else {
        text1 = Messages.get("CenterHint.merge.beginsExtra");
        text2 = Messages.get("CenterHint.merge.endsExtra");
    }

    const messages = [
        { text: text1 },
        { icon: UnitView.getUnitImage(unit, { preferStatic: true }) },
        { text: text2 },
        { icon: UnitView.getUnitImage(nextUnit, { preferStatic: true }) }
    ];
    return messages;
};
